import {
  Box,
  Button,
  Dialog,
  DialogActions,
  IconButton,
  Link,
  ListItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { useDispatch } from "react-redux";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import formatDistanceToNowStrict from "date-fns/formatDistanceToNowStrict";
import { ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as MessageIconRed } from "static/svgs/MessageIconRed.svg";
import { ReactComponent as MessageIconGray } from "static/svgs/MessageIconGray.svg";
import { ReactComponent as NoArtifacts } from 'static/svgs/NoArtifacts.svg'
import { ReactComponent as Addarti } from 'static/svgs/Addarti.svg'
import { ReactComponent as NotificationIcon } from 'static/svgs/Notification Icon.svg'
import icon from "static/Icon.png";
import rightArrow from "static/rightArrow.png";
import { TITLE_MAX_LENGTH } from "utils/constants";
import "./ArtifactPage.css";
import educatorService from "services/educatorService";
import { useSelector } from "react-redux";
import { clearAIHelperProgressRedux } from "redux/slices/aiHelperToolProgress/aiHelperProgressSlice";
import { format, parseISO } from "date-fns";
import React, { lazy, Suspense } from "react";
import { artifactReviewCounts, getColorByTitle } from "utils/componentUtils";
import { v4 as uuidv4 } from 'uuid';
import AddArtifactDialog from "./AddArtifactDialog";
import { ReactComponent as AdaptIcon } from '../../../static/svgs/Skills Initials A.svg';
import { ReactComponent as CollabIcon } from '../../../static/svgs/Skills Initials Col.svg';
import { ReactComponent as CommIcon } from '../../../static/svgs/Skills Initials Com.svg';
import { ReactComponent as CritIcon } from '../../../static/svgs/Skills Initials Cri.svg';
import { ReactComponent as EmpIcon } from '../../../static/svgs/Skills Initials E.svg';
import { ReactComponent as LearnIcon } from '../../../static/svgs/Skills Initials L.svg';
import { ReactComponent as PersonalIcon } from '../../../static/svgs/Skills Initials P.svg';
import { ReactComponent as ResourceIcon } from '../../../static/svgs/ResourceIcon.svg';
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";
import SkillAccordion from "./SkillAccordion";
import { tintRgba } from "utils/componentUtils";

const SidePanel = lazy(() => import("./SidePanel"));
type SkillName =
  | "Adaptability"
  | "Collaboration"
  | "Communication"
  | "Critical Thinking"
  | "Empathy"
  | "Learner's Mindset"
  | "Personal Responsibility";
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgba(7, 27, 34, 1)',
    borderRadius: '6px',
    fontFamily: 'General Sans Variable',
    fontSize: '13px',
    maxWidth: '171px',
    fontWeight: '500',
    lineHeight: '18px',
    paddingTop: '1px'
  },
}));

interface Item {
  id: number;
  title: string;
  description: string;
  created_at: string;
  fileUrl: string;
  areas: any[]; // You may want to replace 'any' with a specific type if available
  comments: any[]; // You may want to replace 'any' with a specific type if available
}

interface Count {
  total: number;
  allItems: number;
}

interface DataResponse {
  items: Item[];
  count: Count;
}

export default function ArtifactsPage({ id, skillsData }: any) {
  const dispatch = useDispatch();
  const navigate = require('react-router-dom').useNavigate();
  const navigateToReview = (id: any) => {
    navigate("/artifact-review/get-started", {
      state: {
        artifactId: id,
        skillsData
      }
    });
  };
  const [open, setOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [value, setValue] = useState<File | null>(null);
  const [fileValueToUpload, setFileValueToUpload] = useState<File | null>(null);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [artifactId, setArtifactId] = useState("");
  const [artifactName, setArtifactName] = useState("");
  const [page, setPage] = useState(1);
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [artifactCount, setArtifactCount] = useState(0);
  const user = useSelector((state: any) => state.account);
  const ITEMS_PER_PAGE = 10;
  const [count, setCount] = useState(0);
  const [types, setTypes] = useState("");
  const [group, setGroup] = useState(false);
  const [buttonState, setButtonState] = useState<Record<number, boolean>>({});
  const fileTypes = ["mp4", "png", "pdf", "JPEG", "JPG"];
  const [panelOpen, setPanelOpen] = useState<boolean>(false);
  const [artifacts, setArtifacts] = useState<DataResponse>();
  const localArtifactdata = useRef<number | undefined>(undefined);

  useEffect(() => {
    dispatch(clearAIHelperProgressRedux());
  }, []);

  const blurPanel = (state: any) => {
    setPanelOpen(state);
    fetchArtifacts();
  };
  const togglePanel = (id: any, name: any) => {
    setArtifactId(id);
    setArtifactName(name);
    setPanelOpen((prevState) => !prevState);
    fetchArtifacts();
  };

  const isDoubleExtensionFileName = (fileName: string) => {
    const fileNameParts = fileName.split('.');

    if (fileNameParts.length > 2) {
      return true
    } else {
      return false;
    }
  };
  const skillNameToIconMap = new Proxy({
    Adaptability: <AdaptIcon />,
    Collaboration: <CollabIcon />,
    Communication: <CommIcon />,
    "Critical Thinking": <CritIcon />,
    Empathy: <EmpIcon />,
    "Learner's Mindset": <LearnIcon />,
    "Personal Responsibility": <PersonalIcon />
  }, {
    get: (target, prop) => target[prop as keyof typeof target] || <AdaptIcon />
  });

  const getFileValueWithRandomName = (fileValue: any) => {
    console.log("value is in getFileFunction: ", fileValue);
    const randomFileName = `${uuidv4()}-${Date.now()}`;
    const partsOfFileName = fileValue.name.split(".");
    const fileExtension = partsOfFileName[partsOfFileName.length - 1];
    const randomFileNameWithExtension = `${randomFileName}.${fileExtension}`;

    const newFile = new File([fileValue], randomFileNameWithExtension, {
      type: fileValue.type,
      lastModified: fileValue.lastModified
    });

    console.log("file value with new name is: ", newFile);
    return newFile;
  };

  const handleChange = (newValue: any) => {
    console.log("New value is: ", newValue);
    if (isDoubleExtensionFileName(newValue.name)) {
      setError("Double extension files are not allowed for security reasons.");
      return;
    }

    if (newValue.size < 50 * 1000 * 1024) {
      setValue(newValue);
      setFileValueToUpload(getFileValueWithRandomName(newValue));
      setTitle(newValue.name.substring(0, TITLE_MAX_LENGTH));
      setError('')
    }
    else {
      setError("This file is larger than 50 MB and can't be submitted.")
    }
  };
  // Function to open the modal
  const handleOpen = () => {
    setValue(null);
    setError("");
    setOpen(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setOpen(false);
    setValue(null);
  };


  const handleUploadErrorMessaging = (uploadError: string) => {
    if (uploadError === "WRONG_FILE_MIME_TYPE") {
      const ErrorValue = "It looks like this file is damaged or incomplete and can't be submitted. Click anywhere in the file upload box to choose a different file."
      setError(ErrorValue);
      return ErrorValue
    }
  };

  const handleAddArtifact = async (e: React.MouseEvent<HTMLButtonElement>): Promise<string> => {
    const button = e.currentTarget;
    button.disabled = true;
    const formData = new FormData();

    if (fileValueToUpload) {
      formData.append("file", fileValueToUpload as Blob);
    }
    if (url) {
      formData.append("url", url);
    }
    let titleCheck = title == '' ? 'Untitled' : title
    formData.append("title", titleCheck);
    formData.append("description", desc == '' ? 'No Description' : desc);
    formData.append("learner_id", id ? id : user.id);
    formData.append("email", user.email);
    formData.append("type", types);
    formData.append("isGroupExperience", group.toString());

    try {
      let upload = await educatorService.uploadArtifacts(formData);

      // Handle duplicate artifact — retry with timestamped title
      if (upload?.data?.error?.includes("PROGRESS_EVIDENCE_EXISTS")) {
        const formData = new FormData();
        if (fileValueToUpload) {
          formData.append("file", fileValueToUpload as Blob);
        }
        if (url) {
          formData.append("url", url);
        }
        const timestamp = Date.now();
        const timeTitle = new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(timestamp);
        const newTitle = `${titleCheck.substring(0, 232)}  ${timeTitle}`;
        setTitle(newTitle);
        formData.append("title", newTitle);
        formData.append("description", desc == '' ? 'No Description' : desc);
        formData.append("learner_id", id ? id : user.id);
        formData.append("type", types);
        formData.append("isGroupExperience", group.toString());
        const retryUpload = await educatorService.uploadArtifacts(formData);
        if (retryUpload?.data?.error?.includes("RESTRICTED_URL") || retryUpload?.data?.error?.includes("GOOGLE_DRIVE_PDF_REQUIRED") || retryUpload?.data?.error?.includes("INVALID_URL")) {
          const restrictedError = retryUpload?.data?.description ?? "This URL is not supported. Please try a different link.";
          setError(restrictedError);
          button.disabled = false;
          return restrictedError;
        }
        await fetchArtifacts();
        return "";
      }
      if (upload?.data?.error?.includes("RESTRICTED_URL") || upload?.data?.error?.includes("GOOGLE_DRIVE_PDF_REQUIRED") || upload?.data?.error?.includes("INVALID_URL")) {
          console.log("Upload response: ", upload);
          const restrictedError = upload?.data?.description
          setError(restrictedError);
          button.disabled = false;
          return restrictedError;
      }
      // Handle error responses (400, 500, etc.)
      if (upload?.status && upload.status >= 400) {
        button.disabled = false;
        if (upload.status == 400 && upload.data?.code) {
          const newError = handleUploadErrorMessaging(upload.data.code) ?? '';
          return newError;
        }
        // Handle validation errors like { url: ["Enter a valid URL."] }
        if (upload.status == 400 && upload.data) {
          const firstKey = Object.keys(upload.data)[0];
          if (firstKey && Array.isArray(upload.data[firstKey])) {
            return upload.data[firstKey][0];
          }
        }
        return upload.data?.message || "Something went wrong. Please try again.";
      }

      // Success
      setError("");
      await fetchArtifacts();
      return ""; // no error
    } catch (err) {
      console.error("Error in handleAddArtifact:", err);
      button.disabled = false;
      return err instanceof Error ? err.message : "Something went wrong. Please try again.";
    }
  };

  const formatRelativeTime = (timestamp: string) => {
    return formatDistanceToNowStrict(new Date(timestamp), { addSuffix: true });
  };

  const fetchArtifacts = useCallback(async () => {
    const artifactData = await educatorService.getArtifacts(id || user.id, page);
    if (artifactData) {
      localArtifactdata.current = artifactData?.items[0]?.id;
      setArtifacts(artifactData);
      setCount(artifactData.count.total);
    }
  }, [id, user.id, page]);

  useEffect(() => {
    if (artifacts) {
      const count = artifactReviewCounts(artifacts)
      setArtifactCount(count);
    }
  }, [artifacts]);

  useEffect(() => {
    fetchArtifacts();
  }, [fetchArtifacts]);

  const handleChangePage = (_: any, newPage: any) => {
    setPage(newPage);
  };

  return (
    <Paper elevation={artifacts != undefined ? 1 : 0}>
      <Box px={5} pt={5} id="artifacts" sx={[artifacts != undefined && { minHeight: "100vh" }]}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",

            // mt: "102px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: "24px",
                lineHeight: "26.4px",
                fontWeight: 600,
                marginRight: 0,
                flex: 1,
              }}
            >
              Artifacts
            </Typography>
            {(artifacts != undefined) && <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: "14px",
                lineHeight: "26.4px",
                fontWeight: 600,
                color: "#071B2299",
                flex: 8,
                marginX: "10px",
              }}
            >
              {artifacts?.count.total != 0 && `${artifacts?.count.total || 0} total, ${artifactCount} need review`}
            </Typography>}
            {(artifacts != undefined && artifacts?.items.length > 0) && <>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "14px",
                  lineHeight: "26.4px",
                  fontWeight: 600,
                  alignContent: "right",
                  color: "#0052D2",
                  cursor: 'pointer'
                }}
                onClick={handleOpen}
                onKeyDown={(e) => {
                  if (e.key == 'Enter') {
                    e.preventDefault();
                    handleOpen()
                  }
                }}
                tabIndex={0}
                role='button'
                aria-label='Add new artifacts'
              >
                Add new Artifacts
              </Typography>
              <Box sx={{ pl: "10px", cursor: "pointer" }}>
                <img src={icon} onClick={handleOpen} />
                {/* <LearnersIcon height="10px" width="10px"/> */}
              </Box>
            </>}
          </Box>
          {(artifacts == undefined || artifacts?.items.length == 0) && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",

                paddingY: "50px",
              }}
            >
              <NoArtifacts />
              <Box sx={{ width: '373px', pl: '43px' }}>
                <Typography sx={{ fontSize: '18px', fontWeight: '600', color: 'rgba(69, 84, 89, 1)', lineHeight: '24px' }}>Demonstrate your skill development by uploading artifacts from your in-school and out-of-school experiences.</Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: '400', pt: '10px', color: 'rgba(69, 84, 89, 1)', pb: '35px', lineHeight: '18px' }}>Artifacts are pieces of evidence (e.g., academic work, reflections, videos of participation in community events)
                  that showcase your Skills. Your assigned Educator will review your Artifacts and provide you with feedback on your Skill development.</Typography>
                {/* <Box sx={{ pt: "30px", cursor: "pointer" }}> */}
                <Button
                  onClick={() => handleOpen()}
                  onKeyDown={(e) => {
                    if (e.key == 'Enter') {
                      e.preventDefault();
                      handleOpen()
                    }
                  }}
                  sx={{
                    maxHeight: "32px",
                    color: "rgba(238, 242, 253, 1)",
                    borderColor: "rgba(7, 27, 34, 1)",
                    borderRadius: '8px',
                    border: '2px solid rgba(7, 27, 34, 1)',
                    backgroundColor: 'rgba(7, 27, 34, 1)',
                    fontWeight: '600',
                    fontSize: '14px',
                  }}
                  startIcon={<Addarti />}
                >
                  Add an artifact
                </Button>
                {/* </Box> */}
              </Box>
            </Box>
          )}
          {artifacts != undefined && artifacts?.items?.length > 0 && (
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                mt: "8px",
                boxShadow: "none",
              }}
            >
              {<TableContainer
                component={Paper}
                sx={{
                  boxShadow: "none",
                }}
              >
                <Table
                  sx={{
                    // borderSpacing: "0 8px",
                    borderCollapse: "separate",

                    "& th, & td": {
                      borderRight: "1px solid rgba(7, 27, 34, 0.12)",
                    },
                    "& th:last-of-type, & th:last-of-type ": {
                      // borderRight: "none",
                    },

                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        Title
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        sx={{
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              fontFamily: "Open Sans",
                              pr: "5px",
                            }}
                          >
                            Skills
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "14px",
                              fontFamily: "Open Sans",
                              pr: "5px",
                            }}
                          >
                            Date Added
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        Comments
                      </TableCell>
                      {user.role === 'ROLE_EDUCATOR' && <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        Review Artifact
                      </TableCell>}
                      {/* <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                      >
                        Open Artifact
                      </TableCell> */}
                      <TableCell
                        sx={{
                          fontWeight: "600",
                          fontSize: "14px",
                          // borderBottom: "none",
                          color: "#071B2299",
                        }}
                        style={{ borderRight: 'none' }}
                      >
                        View Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {artifacts?.items?.map((row: any, index: any) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          border: 1,
                          // borderRadius:'80%',
                          backgroundColor: "#FFFFFF",
                          height: "44px",
                          borderColor: "rgba(7, 27, 34, 0.07)",
                          "&:hover": {
                            backgroundColor: "#F3F4F4",
                            borderColor: "#838D90",
                          },
                          "& > td": {
                            fontWeight: "600",
                            fontSize: "14px",
                            height: "44px",
                          },
                        }}
                      >
                        <TableCell
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "rgba(0, 82, 210, 1)",
                            wordBreak: 'break-all',
                            maxWidth: '150px'
                          }}
                        >
                          <Link
                            href={row.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                          >
                            {row.title.length > 70 ? row.title.slice(0, 70) + "..." : row.title}
                          </Link>
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "14px", fontWeight: "400", maxWidth: '150px' }}
                        >
                          {row.type || "N/A"}
                        </TableCell>
                        <TableCell style={{ maxWidth: '150px', minWidth: '50px' }}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: row?.areas?.length > 0 ? 'flex-start' : 'center', justifyContent: row?.areas?.length > 0 ? 'flex-start' : 'center'}}>
                            {row?.areas.length > 0 ? row?.areas.map((area: any, index: number) => (
                              <span
                                key={index}
                                style={{
                                  padding: "5px",
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <BootstrapTooltip placement='top' title={area?.title}>
                                  {skillNameToIconMap[area.title as SkillName]}
                                </BootstrapTooltip>
                              </span>
                            )) : <span style={{
                                  padding: "5px",
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontSize: '14px',
                                  fontWeight: '400',
                                  fontStyle: 'italic',
                                  color: 'rgba(78, 92, 98, 1)',
                                  maxWidth: '150px',
                                  justifyContent: 'center',
                                  textAlign: 'center'
                                }}>{row.is_reviewed ? 'See educator feedback' : 'Awaiting educator feedback'}</span>}
                          </div>
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "14px", fontWeight: "400" }}
                        >
                          {format(parseISO(row.created_at), "MM/dd/yyyy")}
                        </TableCell>
                        <TableCell>
                          <Box display="flex" flexDirection="row" alignItems="center">
                            {row.comments.length == 0 || row.comments.filter((comm: any) => comm.user?.role === "ROLE_EDUCATOR").length === 0 ?
                              <BootstrapTooltip placement='top'
                                title={<p>Artifact(s) submitted need <span className="clicks" onClick={() => togglePanel(row.id, row.title)}>your review.</span> Thank you!</p>}>
                                <MessageIconRed height="16px" width="16px" />
                              </BootstrapTooltip> : <MessageIconGray height="16px" width="16px" />}
                            <Box display="flex" flexDirection="column" sx={{ pl: "8px" }}>
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  textDecoration: 'underline',
                                  cursor: "pointer",
                                }}
                                onClick={() => togglePanel(row.id, row.title)}
                              >{`${row.comments.filter(
                                (comm: any) =>
                                  comm.user.role === "ROLE_EDUCATOR"
                              ).length
                                } Educator`}</Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Open Sans",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  textDecoration: 'underline',
                                  cursor: "pointer",
                                }}
                                onClick={() => togglePanel(row.id, row.title)}
                              >{`${row.comments.filter(
                                (comm: any) => comm.user.role === "ROLE_LEARNER"
                              ).length
                                } Learner`}</Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        {user.role === 'ROLE_EDUCATOR' && <TableCell
                          sx={{
                            fontSize: "14px",
                          }}
                        >
                          <Box display="flex" flexDirection="row" alignItems="center" gap="6px">
                            <span style={{ width: '18px', display: 'inline-flex', flexShrink: 0 }}>
                              {row.ai_tool_rspn_sts==='COMPLETED' && !row.is_reviewed && <NotificationIcon height="18px" width="18px" />}
                            </span>
                            
                            <i className="fa-regular fa-list-check" style={{ color: row.is_reviewed ? 'rgba(7, 27, 34, 0.4)' : 'inherit' }}/>
                            <Typography
                              title={
                                row.is_reviewed
                                  ? ''
                                  : row.ai_tool_rspn_sts === 'COMPLETED'
                                    ? 'Review (observations ready)'
                                    : 'Review (observations pending)'
                              }
                              sx={{
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                fontSize: "14px",
                                textDecoration: row.is_reviewed ? 'none' : 'underline',
                                cursor: row.is_reviewed ? 'default' : 'pointer',
                                color: row.is_reviewed ? 'rgba(7, 27, 34, 0.4)' : 'inherit',
                                pointerEvents: row.is_reviewed ? 'none' : 'auto',
                              }}
                              onClick={() => {
                                sessionStorage.setItem("artifactId", row.id);
                                navigateToReview(row.id)
                              }
                              }
                            >{row.is_reviewed ? 'Reviewed' : 'Review'}</Typography>
                          </Box>
                        </TableCell>}
                        {/* <TableCell
                          sx={{
                            fontSize: "14px",
                          }}
                        >
                          <Box display="flex" flexDirection="row" alignItems="center">
                                <MessageIconRed height="16px" width="16px" />
                            <Box display="flex" flexDirection="column" sx={{ pl: "8px" }}>
                              <Typography
                                sx={{
                                  fontFamily: "Open Sans",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  textDecoration:'underline'
                                }}
                              >Open</Typography>
                            </Box>
                          </Box>
                        </TableCell> */}
                        {user.role === 'ROLE_LEARNER' ? (
                        <TableCell
                          sx={{
                            fontSize: "14px",
                            color: "rgba(0, 82, 210, 1)",
                          }}
                          style={{ borderRight: 'none' }}
                        >
                          <span
                            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                            onClick={() => togglePanel(row.id, row.title)}
                          >
                            {`View`}
                            <img
                              height="10px"
                              width="5px"
                              style={{ marginLeft: "10px" }}
                              src={rightArrow}
                            />
                          </span>
                        </TableCell>
                        ) : (
                        <TableCell
                          sx={{
                            fontSize: "14px",
                          }}
                          style={{ borderRight: 'none' }}
                        >
                          <Box display="flex" flexDirection="row" alignItems="center">
                            {/* <MessageIconRed height="16px" width="16px" /> */}
                            <Box display="flex" flexDirection="row" gap={1} alignItems="center" sx={{ pl: "8px" }}>
                              <i className="fa-regular fa-telescope" style={{ marginTop: '2px' }}/>
                              <Typography
                                sx={{
                                  fontFamily: "Open Sans",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  textDecoration: 'underline',
                                  cursor: "pointer",
                                }}
                                onClick={() => togglePanel(row.id, row.title)}
                              >View</Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>}
            </Paper>
          )}
          <Suspense fallback={<div>Loading panel...</div>}>
            <SidePanel
              open={panelOpen}
              onClose={() => blurPanel(false)}
              skillsData={skillsData}
              id={id ? id : user.id}
              artifactId={artifactId}
              artifactName={artifactName}
            />
          </Suspense>
        </Box>
      </Box>
      {/* Pagination Footer */}
      {artifacts != undefined && artifacts?.items?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 2,
          }}
        >
          {/* Range and Total Count */}
          <Typography
            sx={{ fontWeight: 700, fontSize: "14px", lineHeight: "19.6px", ml: "20px" }}
          >
            {`${(page - 1) * ITEMS_PER_PAGE + 1}-${Math.min(
              page * ITEMS_PER_PAGE,
              artifacts?.count.total || 0
            )} `}
            <Typography
              component="span"
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "19.6px" }}
            >
              of
            </Typography>
            {` ${artifacts?.count.total || 0} `}
            <Typography
              component="span"
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "19.6px" }}
            >
              results
            </Typography>
          </Typography>

          {/* Pagination Component */}
          <Pagination
            count={Math.ceil(count / ITEMS_PER_PAGE)}
            page={page}
            onChange={handleChangePage}
            siblingCount={1}
            boundaryCount={1}
            color="primary"
            sx={{
              pb: "10px",
              "& .MuiPaginationItem-root": {
                color: "#333",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                fontWeight: "700",
                backgroundColor: "transparent",
                color: "#333",
              },
              "& .MuiPaginationItem-ellipsis": {
                color: "#888",
              },
              "& .MuiPaginationItem-previousNext": {
                color: "#333",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              },
            }}
          />
        </Box>
      )}
      <AddArtifactDialog
        skillsData={skillsData}
        id={id ? id : user.id}
        localArtifactdata={localArtifactdata}
        open={open}
        handleClose={handleClose}
        handleAddArtifact={handleAddArtifact}
        value={value}
        title={title}
        desc={desc}
        url={url}
        error={error}
        uploadProgress={uploadProgress}
        types={types}
        group={group}
        setGroup={setGroup}
        setTypes={setTypes}
        setValue={setValue}
        setFileValueToUpload={setFileValueToUpload}
        setTitle={setTitle}
        setDesc={setDesc}
        setUrl={setUrl}
        setError={setError}
        handleChange={handleChange}
        fetchArtifacts={fetchArtifacts}
      />
    </Paper>
  );
}
